import React from "react";

const MixedText = ({first, second}) => {
  return (
    <span>
      <span className="primary-text">{first} </span>{second}
    </span>
  );
};

export default MixedText;
